import { Component, input, output } from "@angular/core";
import { ButtonDirective } from "primeng/button";
import { Card } from "primeng/card";
import { TPipe } from "../../i18n/t.pipe";

@Component({
  standalone: true,
  selector: "app-client-card",
  imports: [Card, ButtonDirective, TPipe],
  template: `
    @if (client(); as c) {
      <p-card>
        <h3 class="p-pb-0 p-mb-1">{{ c.name }} {{ c.surname }}</h3>
        <p>{{ c.email }}<br />{{ c.phone }}</p>
        @if (c.address || c.zip || c.city) {
          <hr class="full" />
          <p>{{ c.address }}<br />{{ c.zip }} {{ c.city }}</p>
        }
        @if (editable()) {
          <hr class="full" />
          <button type="button" pButton icon="pi pi-user-edit" [label]="' Modifica utente' | t"
            class="p-button p-button-secondary" (click)="edit.emit(c)"></button>
        }
      </p-card>
    }
  `,
})
export class ClientCardComponent {
  readonly client = input<any>(null);
  readonly editable = input(true);
  readonly edit = output<any>();
}
